document.addEventListener('DOMContentLoaded', function() {
  const links = [
    '/collections/signatures',
    '/collections/pour-elle',
    '/collections/pour-lui',
    '/collections/terre-feuilles',
    '/collections/sactum',
    '/collections/estival',
    '/collections/hivernal',
    '/collections/orient'
  ];

  const carousel = document.querySelector('[data-section-id="template--29835886592337__1778060163d214ba86"]');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('img');
  slides.forEach(function(slide, index) {
    if (links[index]) {
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', function() {
        window.location.href = links[index];
      });
    }
  });
});
